/**
 * Notification routes.
 */

export const notificationRoutes = [
  // User notifications list.
  {
    path: "/notification/notifications",
    name: "notificationNotifications",
    component: () =>
      import(/* webpackChunkName: "notificationNotifications" */ "@/views/Notification/NotificationNotifications.vue"),
    meta: {
      role: "none",
      contentOnly: true,
    },
  },
];
